/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */

import onLoad from '../utils/onLoad'
import DOMReady from '../utils/DOMReady'
import getCachedRequest from '../utils/getCachedRequest'

class GolfAds {
  constructor() {
    // Init User Profile ID
    this.setProfileId()

    // No ads for logged in subscribed users
    const { userIsLoggedIn = false, userIsSubscribed = false } = window.wsum
    if (userIsLoggedIn && userIsSubscribed) return

    // These ads load on DOMContentReady
    DOMReady(() => {
      this.headerAndFooterAd()
      this.initSiderail()

      this.initializeAdRightSticky()
    })

    // These ads load on window.load
    onLoad(() => {
      this.insertAdLegacyContent()
      this.insertAdLegacySidebar()
      this.insertAdforBlocks()
      this.initVideoAds()
    })
  }

  /**
   * Fetches the profile ID from 5x5 and sets it in tude
   */
  async setProfileId() {
    const { pid = '' } = window.golf || {}
    if (!pid) return {}
    const userHem = await getCachedRequest('aditute-hem', [
      `https://a.usbrowserspeed.com/cs?pid=${encodeURIComponent(pid)}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      },
    ])
    const { sha256_lower_case: e = '' } = userHem
    if (e) {
      window.tude = window.tude || { cmd: [] }
      window.tude.cmd.push(() => {
        window.tude.setIdProfile({
          e,
        })
      })
    }
    return userHem
  }

  /**
   * Push an ad with window.tude
   *
   * @param {String} divId The Div ID
   * @param {String} baseDivId The Base Div ID
   * @param {String} adLocation The Ad Location
   */
  pushTudeAd(divId, baseDivId, adLocation) {
    window.tude = window.tude || { cmd: [] }
    window.tude.cmd.push(() => {
      window.tude.refreshAdsViaDivMappings([
        {
          divId,
          baseDivId,
          targeting: {
            'ad-loc': adLocation,
            sponsored: '1',
            refresh: true,
          },
        },
      ])
    })
  }

  generateFooterAd() {
    this.destroyFooterAd()
    this.footerAd = document.createElement('div')
    this.footerAd.className = 'golf-ad golf-ad--full golf-ad--billboard stick-to-bottom'
    this.footerAd.setAttribute('data-ad-type', 'leaderboard')
    this.footerAd.innerHTML = '<div class="close-ad">x</div>'
  }

  destroyFooterAd() {
    if (this.footerAd) {
      this.footerAd.remove()
      this.footerAd = null
    }
  }

  headerAndFooterAd() {
    this.footerAd = null
    this.startAdIndex = 1
    this.adBillboard = document.querySelector('.golf-ad--billboard')

    if (this.adBillboard) {
      this.adBillboard.setAttribute('id', 'div-gpt-ad-leaderboard-1')
      this.pushTudeAd('div-gpt-ad-leaderboard-1', 'div-gpt-ad-leaderboard-1', 'leaderboard-1')

      if (this.isMobile()) {
        const headerAdObserver = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.destroyFooterAd()
              } else {
                this.generateFooterAd()
                document.body.appendChild(this.footerAd)
                this.footerAd.setAttribute('id', 'div-gpt-ad-sticky')
                this.pushTudeAd('div-gpt-ad-sticky', 'div-gpt-ad-sticky', 'leaderboard-1')
                this.startAdIndex = 2
              }
            })
          },
          { threshold: [0, 1] },
        )

        headerAdObserver.observe(this.adBillboard)
      } else {
        const featureHeroArticle = document.querySelector(
          'article.feature-hero,article.sponsored-hero',
        )
        let target
        let targetEdge

        // feature hero article doesn't have side rail ad, so a different target is needed
        if (featureHeroArticle) {
          target = document.querySelector('.article__content')
          targetEdge = 'top'
        } else {
          target = document.querySelector('.article__heading')
          targetEdge = 'bottom'
        }

        if (!target) {
          target = document.querySelectorAll('.g-block')[1]
          targetEdge = 'top'
        }

        const siteHeaderHeight = document.getElementById('site-header').offsetHeight

        if (target) {
          this.adScrollListener = () => {
            this.translateBillboard(target, targetEdge, siteHeaderHeight)
          }
          window.addEventListener('scroll', this.adScrollListener, { passive: true })
          const billboardRect = this.adBillboard.getBoundingClientRect()
          const targetRect = target.getBoundingClientRect()

          if (billboardRect.bottom > targetRect[targetEdge]) {
            // billboard is above
            this.translateBillboard(target, targetEdge, siteHeaderHeight)
          }
        } else {
          setTimeout(() => {
            this.adBillboard.classList.add('no-target')
          }, 4000)
        }
      }
    }
  }

  translateBillboard(target, targetEdge, siteHeaderHeight) {
    const targetRect = target.getBoundingClientRect()
    const offset = targetRect[targetEdge] - siteHeaderHeight

    if (offset <= this.adBillboard.offsetHeight) {
      const translateY = Math.min(
        this.adBillboard.offsetHeight,
        this.adBillboard.offsetHeight - offset,
      )
      window.requestAnimationFrame(() => {
        if (translateY >= 350) {
          // reset behavior after first view
          window.removeEventListener('scroll', this.adScrollListener)
          this.adBillboard.style.transform = 'translateY(0)'
          this.adBillboard.style.position = 'relative'
          this.adBillboard.style.top = 0
        } else {
          this.adBillboard.style.transform = `translateY(-${translateY}px)`
        }
      })
    } else {
      window.requestAnimationFrame(() => {
        this.adBillboard.style.transform = 'translateY(0)'
      })
    }
  }

  insertAdforBlocks() {
    this.gutenbergAds = document.querySelectorAll('.horizontal-ad')
    if (this.gutenbergAds) {
      this.gutenbergAds.forEach((ad, adIndex) => {
        const adContainer = ad.querySelector('.golf-ad')
        let adType
        if (adContainer.dataset.keepAdType) {
          // eslint-disable-next-line prefer-destructuring
          adType = adContainer.dataset.adType
        }

        if (!adType) {
          adType = this.isMobile() ? 'medium' : 'leaderboard'
        }

        adContainer.setAttribute('id', `div-gpt-ad-${adType}-${adIndex + 2}`)
        const adname = `div-gpt-ad-${adType}-${adIndex + 2}`
        const adLocation = `${adType}-${adIndex + 2}`
        this.pushTudeAd(adname, adname, adLocation)
        ++this.startAdIndex
      })
    }
  }

  isMobile() {
    return window.matchMedia('(max-width: 767px)').matches
  }

  insertAdLegacyContent() {
    this.legacyLeaderboads = document.getElementsByClassName('ad-demo landscape')
    if (this.legacyLeaderboads) {
      let contentAdIndex = 2
      for (const ad of this.legacyLeaderboads) {
        ad.setAttribute('id', `div-gpt-ad-leaderboard-${contentAdIndex}`)
        const adname = `div-gpt-ad-leaderboard-${contentAdIndex}`
        const adLocation = `leaderboard-${contentAdIndex}`
        this.pushTudeAd(adname, adname, adLocation)
        contentAdIndex++
      }
    }
  }

  insertAdLegacySidebar() {
    this.legacySidebarAds = document.getElementsByClassName('ad-demo sidebar')
    if (this.legacySidebarAds) {
      let LegacyadIndex = 1
      for (const ad of this.legacySidebarAds) {
        ad.setAttribute('id', `div-gpt-ad-medium-${LegacyadIndex}`)
        const adname = `div-gpt-ad-medium-${LegacyadIndex}`
        const adLocation = `medium-${LegacyadIndex}`
        this.pushTudeAd(adname, adname, adLocation)
        LegacyadIndex++
      }
    }
  }

  /**
   * This functionality was migrated from legacy "sidebar2.php" for the "single-best-of" and "single-article-d" templates
   * It duplicates the content in the sidebar to add additional sticky ad spaces for long articles.
   * It could be updated or duplicated to work throughout the site but currently relies on "content" classes
   * only existing on these templates.
   */
  initSiderail() {
    // desktop only
    if (!this.isMobile()) {
      this.sideRails = document.querySelectorAll('.siderail')

      Array.from(this.sideRails).forEach(sideRail => {
        const bottomMargin = 40
        const firstPinHeight = 1000
        const nextPinHeight = 1000
        const smallMax = 2000
        const pins = []
        const pinboards = []

        const { adRailPos = '1' } = sideRail.dataset
        sideRail.style.width = '300px'

        const contentArea = document.getElementById(`content-block-${adRailPos}`)
        const contentHeight = contentArea.offsetHeight

        const ledeMediaArea =
          adRailPos === '2'
            ? 0
            : document.querySelectorAll('.content-section-article-lead-image')[0]

        const mediaAreaHeight = ledeMediaArea === 0 ? ledeMediaArea : ledeMediaArea.offsetHeight
        const contentAreaHeight = contentHeight + mediaAreaHeight

        // abort if the article is too short for sticky behavior
        if (contentAreaHeight < smallMax) {
          // add 'short-article' up sidebar tree
          sideRail.classList.add('short-article')
          sideRail.parentElement.parentElement.classList.add('short-article')

          return
        }

        // "populate pins list"
        const pinItems = Array.from(sideRail.children)
        for (let i = 0; i < pinItems.length; i++) {
          const item = pinItems[i]
          if (item && item.offsetParent) {
            // if the space isn't empty
            sideRail.removeChild(item) // remove it from the right rail to make room for containers
            pins.push(item) // add it to the list if there's something in it
          }
        }

        // un-hide the component now that it's empty
        // its hidden on load to avoid ads appearing then quickly disappearing on load
        sideRail.classList.remove('hide-all') // not seeing hide-all applied, but leaving here anyway
        sideRail.style.height = `${contentAreaHeight}px`

        // add a flexible height container below the last breakout component
        // or, if there are no breakout components, add a single container
        const container = document.createElement('div')
        container.classList.add('spacer')
        container.style.height = '100%'
        sideRail.appendChild(container)

        const containerHeight = parseInt(
          window.getComputedStyle(sideRail).getPropertyValue('height'),
          10,
        ) // could be either an absolute height or a flex height
        const numPinboards = Math.floor(
          containerHeight / (Math.max(nextPinHeight, firstPinHeight) + bottomMargin),
        )

        if (numPinboards > 1) {
          container.classList.add('multi-children')
        }

        // add sticky areas to container
        for (let i = 0; i < numPinboards; i++) {
          const pinboard = document.createElement('div')
          pinboard.classList.add('pinboard')
          container.appendChild(pinboard)
          pinboards.push(pinboard)
        }

        pinboards.forEach((pinboard, i) => {
          // duplicate the component we want to repeat
          if (pins[i % pins.length]) {
            // clone the "pin"
            const newel = pins[i % pins.length].cloneNode(true)
            if (newel.classList.value === 'text-left sticky_ad') {
              newel.children[0].classList.add('golf-ad')
              newel.children[0].dataset.adType = 'medium'
            }
            pinboard.appendChild(newel)
          }
        })
      })
    }
  }

  initializeAdRightSticky() {
    const rightStickyAds = document.querySelectorAll('.golf-ad--right-sticky')
    if (rightStickyAds) {
      rightStickyAds.forEach((ad, adIndex) => {
        const articleWrapper = ad.closest('.article__sidebar-wrapper')
        // Insert rightrail ad if articleWrapper 's height >= 600px and is not mobile
        if (articleWrapper.offsetHeight >= 600) {
          ad.setAttribute('id', `div-gpt-ad-medium-${adIndex + 1}`)
          const adname = `div-gpt-ad-medium-${adIndex + 1}`
          const adLocation = `medium-${adIndex + 1}`
          this.pushTudeAd(adname, adname, adLocation)
        }
      })
    }
  }

  initVideoAds() {
    this.videoContainers = document.querySelectorAll('.preroll-video-container')
    if (this.videoContainers.length) {
      this.videoContainers.forEach(videoContainer => {
        const containerId = videoContainer.getAttribute('id')
        if (containerId) {
          window.tude = window.tude || { cmd: [] }
          window.tude.cmd.push(function () {
            window.tude.requestVideoAd({
              divId: containerId,
              code: 'swingu',
            })
          })
        }
      })
    }
  }
}

const golfAdsInit = {
  init() {
    return new GolfAds()
  },
}

export default golfAdsInit
